import { AllHTMLAttributes, ReactNode } from "react";
import styles from "./card-head.module.css";

export type CardHeadProps = {
  children: ReactNode;
} & AllHTMLAttributes<HTMLDivElement>;

export function CardHead({ children, ...props }: CardHeadProps) {
  return (
    <div className={styles.Head} {...props}>
      {children}
    </div>
  );
}
